import WarningAlert from "./WarningAlert";

export default WarningAlert;
